import React from "react";

export default () => (
  <div>
    <h1>Access manager</h1>
    <p>Manage Fischer OAuth roles and permissions.</p>
    <ul>
      <li>Roles are functional job descriptions from ldap</li>
      <li>
        Permissions are application specific permissions assigned to roles
      </li>
    </ul>
  </div>
);



// WEBPACK FOOTER //
// ./src/containers/HomePage/HomePage.js